import { styled } from 'styled-components';
import { ToggleInput } from '@neteera/neteera-web-nextgen';

export const StyledToggleInput = styled(ToggleInput)`
  flex-direction: row-reverse;
  border: none;
`;
